import { FiCheckCircle } from "react-icons/fi";
import { DueDiligenceFeedbackStatus } from "../../Common/Hooks/useApi/Schemas";
import { FeedbackFooterWrapper, FeedbackFooterTitle, FeedbackFooterNpsRow, NpsCircle, SubmittedBadge } from "./Styles";

const NPS_VALUES = Array.from({ length: 11 }, (_, i) => i);

interface FeedbackFooterPromptProps {
  feedbackStatus: DueDiligenceFeedbackStatus | null;
  onScoreClick: (score: number) => void;
}

// Bottom-of-page prompt, not a report "section" so it never lands in the
// section nav sidebar. Clicking a score opens the full modal with that score
// already selected. Always available once we know the status (independent of
// the one-time automatic banner) — shows the "already submitted" badge instead
// once feedback exists.
export const FeedbackFooterPrompt = ({ feedbackStatus, onScoreClick }: FeedbackFooterPromptProps) => {
  if (!feedbackStatus) return null;

  if (feedbackStatus.alreadySubmitted) {
    return (
      <FeedbackFooterWrapper>
        <SubmittedBadge>
          <FiCheckCircle size={16} />
          Feedback enviado
        </SubmittedBadge>
      </FeedbackFooterWrapper>
    );
  }

  return (
    <FeedbackFooterWrapper>
      <FeedbackFooterTitle>¿Te ha sido útil?</FeedbackFooterTitle>
      <FeedbackFooterNpsRow>
        {NPS_VALUES.map((value) => (
          <NpsCircle key={value} type="button" $selected={false} onClick={() => onScoreClick(value)}>
            {value}
          </NpsCircle>
        ))}
      </FeedbackFooterNpsRow>
    </FeedbackFooterWrapper>
  );
};
